/**
 * Class applied to each remote collaborator presence box drawn on the presence layer.
 */
export const PRESENCE_BOX_CLASS = 'presence-box';

/**
 * Modifier added to a presence box while the pointer is over it. Because the box
 * keeps `pointer-events: none` (so the grid stays clickable), hover is detected
 * in JS and surfaced through this class, which reveals the nameplate via CSS.
 */
export const PRESENCE_BOX_HOVERED_CLASS = 'presence-box--hovered';

/**
 * Class applied to the nameplate child appended to a presence box.
 */
export const PRESENCE_NAMEPLATE_CLASS = 'presence-nameplate';
